/**
 * Test IDs for QA automation.
 */
export const testIds = {
  organizationInfosFormCompanyName: "organization-infos-form-company-name",
  organizationInfosFormDotNumber: "organization-infos-form-dot-number",
  organizationInfosFormTaxId: "organization-infos-form-tax-id",
  organizationInfosFormAddress: "organization-infos-form-address",
  organizationInfosFormEmail: "organization-infos-form-email",
  organizationInfosFormContact: "organization-infos-form-contact",
  organizationInfosFormEdit: "organization-infos-form-edit",
} as const;
